/**
 * The four KYB steps (registration → check → decision → badge) with the
 * company's progress, plus a collapsible "how it works" that states the
 * product rules from docs/decisions/kyb.md in plain words.
 */
import { useTranslation } from "react-i18next";
import { FLOW_STEPS, type FlowStep, type StepState } from "@/lib/kyb";
import "@/components/KybStatus/KybFlow.css";

export const KybFlowSteps = ({ states }: { states?: Record<FlowStep, StepState> }) => {
  const { t } = useTranslation("kyb");
  return (
    <ol className="kyb-flow" aria-label={t("flow.ariaLabel")}>
      {FLOW_STEPS.map((step, i) => {
        const state = states?.[step] ?? "todo";
        return (
          <li key={step} className={`kyb-flow__step kyb-flow__step--${state}`}>
            <span className="kyb-flow__num">{state === "done" ? <i className="fa-solid fa-check" /> : i + 1}</span>
            <div>
              <p className="kyb-flow__label">{t(`flow.steps.${step}.label`)}</p>
              <p className="kyb-flow__hint">{t(`flow.steps.${step}.hint`)}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

const RULES = ["moderatorChooses", "evidenceOnly", "badgeLimited", "override", "pause", "gate"] as const;

export const KybHowItWorks = ({ defaultOpen = false }: { defaultOpen?: boolean }) => {
  const { t } = useTranslation("kyb");
  return (
    <details className="kyb-explainer" open={defaultOpen}>
      <summary>{t("howItWorks.title")}</summary>
      <KybFlowSteps />
      <ul className="kyb-explainer__rules">
        {RULES.map((rule) => (
          <li key={rule}>{t(`howItWorks.rules.${rule}`)}</li>
        ))}
      </ul>
    </details>
  );
};
